import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyArrowRightIcon } from './img/arrow-right.svg'

type ArrowRightIconProps = IconWrapperProps

export const ArrowRightIcon: FC<ArrowRightIconProps> = ({
  className,
  ...props
}) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyArrowRightIcon />
    </IconWrapper>
  )
}
